import { t, Trans } from '@lingui/macro'
import { Checkbox, FormControlLabel, Grid, Radio, Typography } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import { RadioGroup } from 'formik-material-ui'
import React, { useCallback } from 'react'
import { myI18n } from 'translation/I18nConnectedProvider'
import { NumberFormatCustom } from '../common-components/FormElement'
import { TextFieldWithFormik } from '../common-components/with-formik/TextFieldWithFormik'
import { indexToOption } from './QuestionWidget'
import { nonApplicableSuffix, questionToInitial } from './SurveyTab'
import { SurveyQuestion } from './surveyTypes'

export const SurveySelectOneQuestion: React.FC<{ disabled: boolean, nonApplicableDisabled: boolean, question: SurveyQuestion, id: string, hideError: boolean }> = ({
  disabled,
  hideError,
  id,
  question,
  nonApplicableDisabled
}) => {
  const { setFieldValue, setValues, values } = useFormikContext<Record<string, any>>()
  const { options = [], nonApplicable, isRequired } = question

  const nonApplicableSelected = values[id + nonApplicableSuffix] === true
  const questionValue = values[id]

  const handleChange = useCallback((e: React.SyntheticEvent<Element>) => {
    if (nonApplicableSelected) {
      void setFieldValue(`${id}` + nonApplicableSuffix, false)
    } else {
      void setFieldValue(id, (e.target as HTMLInputElement).value)
    }
    if (values[id + '_other'] != null) {
      void setFieldValue(`${id}_other`, null)
    }
  }, [setFieldValue, id, values, nonApplicableSelected])

  return (
    <Field
      component={RadioGroup}
      name={id}
      disabled={disabled}
      style={{
        width: '100%'
      }}
    >
      {options?.map((item, index) => {
        const selected = questionValue === indexToOption(index)
        return (
          <Grid key={index} container direction='column'>
            <FormControlLabel
              style={{ marginLeft: 10, marginTop: 3 }}
              key={index}
              value={indexToOption(index)}
              control={<Radio
                disabled={disabled}
                checked={selected}
                sx={{
                  color: !hideError && questionValue == null && isRequired
                    ? 'error.main'
                    : undefined
                }}
                       />}
              label={
                <Typography className='survey-question-text' style={{ textAlign: 'left' }}>
                  {item.text}
                </Typography>
                            }
              onChange={handleChange}
              disabled={disabled}
            />
            {selected && item.requireDetails != null && (
              <TextFieldWithFormik
                name={`${id}_other`}
                style={{ marginLeft: 15, marginRight: 15 }}
                variant='outlined'
                placeholder={myI18n._(t`Please, specify`)}
                fullWidth
                disabled={disabled}
                InputProps={item.requireDetails === 'number'
                  ? { inputComponent: NumberFormatCustom }
                  : {}}
              />
            )}
          </Grid>
        )
      })}
      {question.nonApplicable && (
        <FormControlLabel
          sx={{ ml: '10px' }}
          checked={nonApplicableSelected}
          control={<Checkbox />}
          label={
            <Typography className='survey-question-text'>
              <Trans>Is non applicable</Trans>
            </Typography>
                      }
          onChange={e => {
            const toSet = { ...values }
            toSet[id + nonApplicableSuffix] = (e.target as HTMLInputElement).checked
            toSet[id] = questionToInitial(question)[1]
            void setValues(toSet)
          }}
          disabled={nonApplicableDisabled}
        />
      )}
    </Field>
  )
}
